$(document).ready(function(){

    function fetchVarients(e, $thisItem, action){
        let $this = $thisItem
        if(action == 'hover'){
            $this = $thisItem.find('.product-colour__item--current');
        }
        let variants = $this.data("variants");
        if(variants) {
            const getColor = $this.data("color");
            var productId = $this.data("productid");
            const prepareArray = {};
            variants.forEach(item => {
                if (item.available && item.option2) {
                    if (Object.keys(prepareArray).length > 0 && Object.keys(prepareArray).includes(item.option2.toLowerCase())) {
                        prepareArray[item.option2.toLowerCase()].push(item.option1)
                    } else {
                        prepareArray[item.option2.toLowerCase()] = [item.option1]
                    }
                }
            });
            $(".item-size-" + productId).each(function (i, v) {
                if(!prepareArray[getColor] || !prepareArray[getColor].includes($(this).children('span').text()) ) {
                    $(this).addClass('variant-selector__item--disabled')
                }
                else {
                    $(this).removeClass('variant-selector__item--disabled')
                }
            });
        }

    }

    $(document).on('click', '.product-colour__item', function (e){
        fetchVarients(e, $(this), 'click');
    })
    $(document).on('mouseenter', '.card--product', function (e){
        fetchVarients(e, $(this), 'hover');
    })




    var dynamicCart = false;
    let currentDynamicCart = dynamicCart; // fallback to global initially
    var currencyJSON = {
        AUD: {symbol: "$"},
        NZD: {symbol: "$"},
        USD: {symbol: "$"},
        EUR: {symbol: "\u20AC"}
    }

    $(document).on('click','.button--product-quick-add, .mobile-bag-quick-add',function(){
        const variants = $(this).data('variant')
         var productId = $(this).data("productid");
                var selectedVariantId = $(this).data('variant-id');
                var that = $(this)
                var inputId = $(this).attr("for");
                var value = $("#"+inputId).val();
                var clr;
                var loading = '<div><div class="spin-loading spin-loading--quick-add"><span class="spin-loading__icon"></span></div></div>'
                $(".item_color_"+productId).each(function(){
                    if($(this).hasClass("product-colour__item--current")){
                        clr = $(this).data("color")
                    }
                });
                var variantId="";
                if(clr){
                    for(data in variants){
                        if(variants[data].option1.toLowerCase() == clr ) {
                            variantId = variants[data].id;
                            break;
                        }
                    }
                }else{
                    variantId = selectedVariantId;
                }
        console.log('script varId',variantId)
        $.ajax({
            method:"POST",
            url: window.Shopify.routes.root + "cart/add.js",
            dataType:"json",
            contentType: 'application/json',
            data:JSON.stringify({id: variantId, quantity:1, properties: {}}),
            beforeSend:function(){
               // $('.card__quick-add').prepend(loading);
                $(that).hide();
                $(that).parent().append(loading)
             }
        }).done(function() {
            getData(true, true);
            $(that).find('div').remove();
            setTimeout(function(){
            $(that).show();
            },2000)
        })
    })

    $(document).on('click','.product-quick-add__mobile .button--quick-add',function(){
        window.tempElem = $(this);
        $('body').append('<div class="test-elem"></div>');
        sizeHtml = $(this).parent().find('.modal--quick-add');
        $('body').find('.test-elem').append( sizeHtml);
        $('body').find('.test-elem').find('.modal').css({'position':'fixed','display':'flex','transform':'translateY(0%)'})
        $('.spin-loading').hide();

    })

    $(document).on('click','.test-elem .modal__button', function (e){
        window.modalClose = $(this)
        $(this).parent().parent().parent().css({'position':'fixed','display':'flex','transform':'translateY(100%)'})
        $('body .test-elem').remove();
        $(window.tempElem).parent().append(sizeHtml);
    })


    $(document).on('click', '.mobile-size-selector__item.variant-selector__item' ,function(){
        var that = $(this)
        $(window.tempElem).parent().append(sizeHtml);

        var variants = $(this).data("variants");
        var productId = $(this).data("productid");
        var inputId = $(this).attr("for");
        var value = $("#"+inputId).val();
        var color ="";
        $(".item_color_"+productId).each(function(){
            if($(this).hasClass("product-colour__item--current")){
                color = $(this).data("color")
            }
        });
        var variantId="";
        for(data in variants){
            if(variants[data].option1 == value && variants[data].option2.toLowerCase() == color ) {
                variantId = variants[data].id;
                break;
            }
        }

        var loading = '<div class="spin-loading spin-loading--product-quick-add"><span class="spin-loading__icon"></span></div>';
        var mobileLoading = '<div><div class="spin-loading spin-loading--product-quick-add"><span class="spin-loading__icon"></span></div></div>';
        $.ajax({
            method:"POST",
            url: window.Shopify.routes.root + "cart/add.js",
            dataType:"json",
            contentType: 'application/json',
            data:JSON.stringify({id: variantId, quantity:1, properties: {}}),
            beforeSend:function(){
                if($(document).find($(that).hasClass('mobile-size-selector__item'))){
                    $(that).parent().parent().hide()
                    $(that).parent().parent().parent().find('.spin .spin-loading').css('display','block');
                }
            }
        }).done(function() {
            getData(true, true);
            $(that).parent().parent().show()
            $(that).parent().parent().parent().parent().find('.spin .spin-loading').css('display','none');

           // $('.spin .spin-loading').css('display','none')
            $('.test-elem').find('.modal').css({'position':'fixed','display':'flex','transform':'translateY(100%)'});
            $('.test-elem').find(window.modalClose).parent().parent().parent().css({'position':'fixed','display':'flex','transform':'translateY(100%)'});
            $(that).closest('.modal--quick-add').css({'position':'fixed','display':'flex','transform':'translateY(100%)'});

        })


    })

    $(document).on('click',".desktop-size-selector__item.variant-selector__item",function() {
        console.log('click variant-selector__item...')
        var that = $(this)
        var variants = $(this).data("variants");
        var productId = $(this).data("productid");
        var inputId = $(this).attr("for");
        var value = $("#"+inputId).val();
        var color ="";
        $(".item_color_"+productId).each(function(){
            if($(this).hasClass("product-colour__item--current")){
                color = $(this).data("color")
            }
        });
        var variantId="";
        for(data in variants){
            if(variants[data].option1 == value && variants[data].option2.toLowerCase() == color ) {
                variantId = variants[data].id;
                break;
            }
        }

        var loading = '<div class="spin-loading spin-loading--product-quick-add"><span class="spin-loading__icon"></span></div>';
        var mobileLoading = '<div><div class="spin-loading spin-loading--product-quick-add"><span class="spin-loading__icon"></span></div></div>';
        $.ajax({
            method:"POST",
            url: window.Shopify.routes.root + "cart/add.js",
            dataType:"json",
            contentType: 'application/json',
            data:JSON.stringify({id: variantId, quantity:1, properties: {}}),
            beforeSend:function(){


                   $(that).parent().parent().hide()
                   $(that).parent().parent().parent().append(loading)



            }
        }).done(function() {
            getData(true, true);
            $(that).parent().parent().show();
            //$(that).parent().parent().parent().remove(loading)
        })

    })

    // fix stale cache issue when user clicks browser back button from checkout page
    window.addEventListener("pageshow", function(event) {
      if (
        event.persisted ||
        performance.getEntriesByType("navigation")[0].type === "back_forward"
      ) {
        if (typeof getData === "function") {
          getData(false, true); // refresh cart silently without opening it
          console.log(
            "cart refreshed on page show (bfcache or back-forward navigation)"
          );
        }
      }
    });

    /**
     * render the cart slideout
     *
     * @param {boolean} cartToggle - true if cart should be opened after rendering
     * @param {boolean} [overrideDynamicCart] - optional override for global dynamicCart
     * @returns {void}
     **/
    function getData(cartToggle, overrideDynamicCart) {
        currentDynamicCart = typeof overrideDynamicCart === 'boolean' ? overrideDynamicCart : dynamicCart;
        console.log('getData, dynamicCart=', currentDynamicCart ? 'Yes' : 'No', ', cartToggle=', cartToggle ? 'Yes' : 'No');

        $.ajax({
            method:"GET",
            url: window.Shopify.routes.root + "cart?view=ajax",
            dataType:"json",
            contentType: 'application/json',

        }).done(function(cart){
            $('.card__quick-add .spin-loading').remove();
            $('.cart-trigger__button .cart-trigger__count').remove();
            var item_count = cart['items'].length;
            var total_quantity = 0;
            var total_price = cart['total_price']/100;
            //console.log("cart.currency:" + cart.currency);
            var getCurrency = "$";
            if (currencyJSON[cart.currency] !== undefined) {
                getCurrency = currencyJSON[cart.currency].symbol;
            }
            var subTotal = `${getCurrency}${((cart.items_subtotal_price)/100).toFixed(2)}`;

            var cart_list = [];

            for( var i = 0; i < item_count; i++ ){
                if ( cart['items'][i].id != null ) {

                    var item_id = cart['items'][i].id;
                    var product_title = cart['items'][i]['product_title'];
                    var product_handle = cart['items'][i]['handle'];
                    var quantity = cart['items'][i]['quantity'];
                    total_quantity += quantity;
                    var line_price = `${getCurrency}${(cart['items'][i]['final_line_price']/100).toFixed(2)}`
                    var url = cart['items'][i]['url'];
                    var image_url = cart['items'][i]['image'];
                    var variants = cart['items'][i]['variant_options'];

                    if ( product_title == 'Gift Wrap' ) {
                        var product_url = product_title;
                    } else {
                        var product_url = '<a href="' + url + '">' + product_title + '</a>';
                    }

                    var options = [];
                    for ( var o = 0; o < variants.length; o++ ) {
                        var selected = cart['items'][i]['options_with_values'][o];
                        if ( selected !== 'Default Title' ) {
                            options.push( selected.name +' : ' + selected.value + '</br>' );
                        }
                    }
                    var selected_options = options.join(' ');


                    cart_list.push(
                        '<div class="cart-row cart-row--slideout">\
                            <div class="cart-row__inner">\
                                <a href="' + url + '" class="cart-row__col cart-row__col--image">\
                                                <img data-sizes="auto" class="img-fluid d-block" src="' + image_url + '"  alt="' + product_title + '" loading="lazy" />\
                                            </a>\
                                        <div class="cart-row__col cart-row__col--content">\
                                        <div class="cart-row__header">\
                                            <h5 class="cart-row__title">' + product_title + '</h5>\
                                            <div class="cart-row__info">\
                                            <span class="cart-row__variant cart-row-variant">' + selected_options + '</span>\
                                            </div>\
                                            <div class="cart-row__footer">\
                                                <div class="quantity--cart-slideout quantity">\
                                                    <div class="quantity__control">\
                                                        <button class="quantity__button minus" role="button" type="button">-</button>\
                                                        <input type="number" class="quantity__input input-quantity" name="updates[]" id="updates_' + item_id + '" value="' + quantity + '" min="1" />\
                                                        <button class="quantity__button plus" role="button" type="button">+</i></button>\
                                                    </div>\
                                                </div>\
                                            <span class="cart-row__price">' + line_price + '</span>\
                                            </div>\
                                            </div>\
                                                <button  type="button" id="miniCartRemove" data-mini-variant="" data-mini-qty="quantity"  class="link cart-row__close button--close">Remove</button>\
                                        </div>\
                                    </div>\
                                    </div>'
                    );
                }
            }
            var bottomHtml ='<div class="cart-slideout__bottom">' +
                '<div class="cart-slideout__subtotal"><span>Subtotal</span> <span>'+ subTotal + '</span></div>'+
                '<div class="cart-slideout__buttons">'+
                '<button type="submit" name="checkout" class="button button--block cart-slideout__button">Checkout now</button>'+
                '<a href="/cart" class="link cart-slideout__cta cart-slideout-cta"><span>View your shopping bag</span>'+
                '<svg viewBox="0 0 6 8" class="cart-slideout-icon-caret icon icon-caret"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-caret" x="0" y="0"></use></svg></a>'+
                '</div>';



            var prepareMainHtml ='<div class="cart-layout__inner">' +
                '<div class="cart-slideout__wrapper">' +
                '<div class="grid grid--no-gutter">' +
                '<div class="cart-slideout__items">' + cart_list.join('')+
                '</div>'+ bottomHtml +'</div></div></div>';


            var emptyCart = '<div>'+
                '<h4 class="cart-slideout__empty-text">You bag is currently empty.</h4>'+
                '</div>';
            var cartCount = '<span class="badge cart-trigger__count" style="display:flex;">' +
                '<span class="cart-trigger__count-text cart-trigger-count-text">' + total_quantity + '</span></span>';

            $('.cart-slideout__content').html(prepareMainHtml);

            if(cartToggle) {
                $('.cart-trigger__button').trigger("click");
            }
            if(cart.items == 0){
                $('.cart-slideout__content').html(emptyCart);
            }
            if(cart.items.length > 0){
                $('.cart-trigger__button').append(cartCount);
            }

        })
    }


    $('body').on('click','.cart-row__close', function (){
        if(currentDynamicCart) {
            let qty = $(this).parent('.cart-row__col').find('.input-quantity').val();
            let itemId = $(this).parent('.cart-row__col').find('.input-quantity').attr('id').split('_').pop();


            $.ajax({
                method: "POST",
                url: window.Shopify.routes.root + "cart/change.js",
                dataType: "json",
                headers: {'Content-Type': 'application/json'},
                contentType: 'application/json',
                data: JSON.stringify({quantity: "0", id: itemId}),
            }).done(function () {
                getData(false, true);
            })
        }
    })

    $('body').on('click', '.quantity__button', function(){
        if(currentDynamicCart) {
            let qty = $(this).parent('.quantity__control').find('.input-quantity').val();
            let itemId = $(this).parent('.quantity__control').find('.input-quantity').attr('id').split('_').pop();
            if($(this).hasClass('plus')){
                let updatedQty = ++qty;
                $.ajax({
                    method: "POST",
                    url: window.Shopify.routes.root + "cart/change.js",
                    dataType: "json",
                    headers: {'Content-Type': 'application/json'},
                    contentType: 'application/json',
                    //data: JSON.stringify({updates:[updatedQty]}),
                    data: JSON.stringify({quantity: qty++ , id: itemId}),
                }).done(function () {
                    getData(false, true);
                })
            }
            if($(this).hasClass('minus')){
                let updatedQty = --qty;
                $.ajax({
                    method: "POST",
                    url: window.Shopify.routes.root + "cart/change.js",
                    dataType: "json",
                    headers: {'Content-Type': 'application/json'},
                    contentType: 'application/json',
                    //data: JSON.stringify({updates:[updatedQty]}),
                    data: JSON.stringify({quantity: qty--, id: itemId}),
                }).done(function () {
                    getData(false, true);
                })
            }

        }
    })



    $(document).on('click',".product-colour__item",function(){
        if(!$(this).hasClass("product-colour__item--current")){
            $(this).addClass("product-colour__item--current");
            $(this).siblings().removeClass('product-colour__item--current');
        }
        var variants = $(this).data("variants");
        var productId = $(this).attr('data-productid');
        var prodClr = $(this).attr('data-color');
        var originalProdClr = $(this).attr('data-color-original');


        var prodId="";
        var prodId = variants.filter((variant) => {
            return variant.option2 == prodClr;
        })
        var singleProd = prod_json.filter(prod => {
            return prod.id == productId;
        })
        var PATTERN = prodClr,
            selectedImgs = singleProd[0].images.filter(function (str) { return str.indexOf(PATTERN) > 0; });
        var firstImg = selectedImgs[0]
        var secondImg = selectedImgs[1]
        var elem = $(this).parents('.card__inner').find('.card__image-wrapper figure');
        $(elem[0]).find('img').attr('src',firstImg)
        $(elem[1]).find('img').attr('src',secondImg)

    })


        $('.custom-collection .js-collection-grid .grid__item').each(function(i,v){

            var clrLen = $(this).find('.card__content .product-colour__items').data('clrs');
            var imgs = $(this).find('.card__content button.product-colour__item').data('imgs');
            var clrBtn = $(this).find('.card__content button.product-colour__item')
            var pId = $(this).find('.card__content button.product-colour__item').data('productid')
            var variants = $(this).find('.card__content button.product-colour__item').data('variants')
            //console.log('variants', variants)
            var varPositions = [];
            var finalPositions = [];
            var exactIndexes = [];
            var newImgIndexes = [];
          for(vars in variants){
                //console.log('featured image positions',variants[vars].featured_image.position)
              if(variants[vars].featured_image !== null ){
                varPositions.push(variants[vars].featured_image.position)
              }
            }

            if (Array.isArray(varPositions) && varPositions.length === 0) {
                return;
            }

            let uniquePos = [...new Set(varPositions)];
            var sorted = uniquePos.sort(function(a,b){
                return a - b;
            })

            var splicedArr = uniquePos.splice(0,1);
            $(uniquePos).each(function(a){
                exactIndexes.push(uniquePos[a]-1);
            })
            finalPositions.push(uniquePos)
            exactIndexes.push($(imgs).length)
            if(clrBtn.length > 0) {
                exactIndexes.forEach(function(v,i) {
                    var i = v - 1;
                    if (arr[i] !== undefined) {
                        console.log('push.imgs[' + i + ']:' + imgs[i]);
                        newImgIndexes.push(imgs[i]);
                    }
                })
            }
            clrBtn.each(function (btnIndex) {
                $(this).find('label').css('background-image', 'url("' + newImgIndexes[btnIndex] + '")');
            });

        })

    // make sure the getData function is available globally
    window['collection-swatch-get-data'] = getData;
})
